import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueGallery from 'vue-gallery'
import {
  faThumbsUp, faList, faMapMarkerAlt, faCircleNotch, faTimes,
  faInfoCircle, faCalendar, faFrown, faArrowRight, faArrowLeft, faPhoneAlt, faEnvelope
} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

Vue.component('VGallery', VueGallery)
Vue.component('font-awesome-icon', FontAwesomeIcon)

const icons: any[] = [faThumbsUp, faList, faMapMarkerAlt, faFrown,
  faCircleNotch, faTimes, faInfoCircle, faCalendar, faArrowRight, faArrowLeft, faPhoneAlt, faEnvelope]
library.add(...icons)
